import { NavLink } from 'react-router-dom';

import { useNavContext } from '../../../providers/navigation/navigation.provider';

import { useNavLinkStyles } from './nav-link.styles';

const CustomNavLink = ({ route, style }) => {
  const { toggleSideNav, sideNavOpen } = useNavContext();

  const classes = useNavLinkStyles();

  return (
    <li className={classes.tnLinkWrapper}>
      <div className={classes.tnLink}>
        <NavLink
          style={style}
          onClick={() => {
            if (sideNavOpen) {
              toggleSideNav();
            }
          }}
          className={({ isActive }) => (isActive ? classes.linkActive : '')}
          to={route.route}
        >
          {route.name}
        </NavLink>
      </div>
    </li>
  );
};

export default CustomNavLink;
